export default "__VITE_ASSET__CnKiQgUq__"